import { render, staticRenderFns } from "./ModalImportar.vue?vue&type=template&id=b491ed98&"
import script from "./ModalImportar.vue?vue&type=script&lang=js&"
export * from "./ModalImportar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports